export const LicenseStatus = {
  Ativo: 1,
  Inativo: 0,
};
